// AI Generated Test
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PagePerformanceChartsService } from '../charts/page-performance-charts/page-performance-charts.service';

@Component({
    selector: 'page-performance-score-indicators',
    standalone: false,
    template: `
        <div class="page-performance-score-indicators d-flex flex-column flex-wrap justify-content-between">
            <div class="score-container text-nowrap ml-2 mb-2">
                <span class="score-color-indicator mr-1" [style.background-color]="getPassedColor()"></span>
                <span class="inline-block text-bold">90-100</span>
            </div>
            <div class="score-container text-nowrap ml-2 mb-2">
                <span class="score-color-indicator mr-1" [style.background-color]="getAverageColor()"></span>
                <span class="inline-block text-bold">50-89</span>
            </div>
            <div class="score-container text-nowrap ml-2 mb-2">
                <span class="score-color-indicator mr-1" [style.background-color]="getFailedColor()"></span>
                <span class="inline-block text-bold">0-49</span>
            </div>
        </div>
    `,
})
export class PagePerformanceScoreIndicatorsComponent {
    @Input() audits: any;
    @Output() goToSection = new EventEmitter<any>();

    constructor (
        private pagePerformanceChartsService: PagePerformanceChartsService,
    ) {}

    getFailedColor (): string {
        return this.pagePerformanceChartsService.getFailedColor();
    }

    getAverageColor (): string {
        return this.pagePerformanceChartsService.getAverageColor();
    }

    getPassedColor (): string {
        return this.pagePerformanceChartsService.getPassedColor();
    }
}
